import { render, staticRenderFns } from "./POSProducts.vue?vue&type=template&id=127908b3&"
import script from "./POSProducts.vue?vue&type=script&lang=js&"
export * from "./POSProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports